import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import SheetTitle from '../../../components/SheetTitle';
import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function FindMusic() {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/how-to-find-music" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="How do I find music?" />
      <p>
        In order to find music, please go to <strong>search field</strong> in the header and type in the name of
        the <strong>track</strong> and/or <strong>artist</strong> you are looking for. Also, you can look for
        <strong>releases</strong> in the same way.
      </p>
      <p>
        Additionally, you can search by world charts, last added, music series and genres. To do this, please
        go <strong>to the left navigation bar</strong> and choose the desired section.
      </p>
      <p>
        In the <Link to="/chart">World Charts</Link> section, you have an option to see the 6 top charts and find the music that
        is most popular today according to them.
      </p>
      <p>
        The <Link to="/last-added">Last Added</Link> section is there to see what’s new on Mp3Caprice and browse the recent releases.
      </p>
      <p>
        <Link to="/series">Music Series</Link> is the list of music collections, provided by labels. Choosing a category shows
        all the releases of the collection. Please use the quick search in the top right corner to find the music in
        your favorite series.
      </p>
      <p>
        In the <Link to="/genre">Music Genres</Link> section, you can find a vast variety of genres available at Mp3Caprice.
        Please use the quick search in the top right corner to find the music in your favorite genres.
      </p>
      <HelpContactUs subject={2} />
    </div>
  );
}
